import React from 'react'
import { SideEve } from '../constants/index'
import navdbg from '../assests/navdbg.png'
import Arrow from '../assests/Arrow.png'
import {Foot} from '../constants/index'
function SideEvent() {
  return (
    <section className='w-full h-[780px] bg-slate-700 relative -z-20 '>
    <div className='w-full h-[500px] bg-slate-700   '>
            <div className='absolute bottom-0 right-0'><img src={navdbg} alt='nav down' className='items-end'/></div>
            <div className='flex flex-row justify-between'>
        <div>           
           <p className='text-[16px] font-semibold pl-10 pt-4 text-white'>GHSO24</p>
            <p className='text-[26px] font-semibold pl-10   text-white'>Side Events</p>
         </div>
         <div>
            <img src={Arrow} alt='arow' className=' pt-10 pr-10'/>
         </div>
 
        </div>
        {
            SideEve.map((ele,ind)=>(
        <div className='w-[327px] h-[150px]  bg-white mb-4 flex flex-row justify-between rounded-2xl mt-4 mx-auto'>
            <div className='w-[100px] mt-2 pl-3'>
             <img src={ele.img1} alt='img1' className='absolute'/>
             <img src={ele.img2} alt='img2' className='relative top-7 left-5'/>
            </div>
            <div className='w-[200px] h-[200px] '>
                <h1 className='w-[139px] mt-4 font-bold'>{ele.furm}</h1>
                <p >{ele.dates}</p>
                <p className='w-[200px] tracking-tighter'>{ele.loc}</p>
            </div>
        </div>
        ))
        }
    
        <div className='w-full h-[50px] rounded-t-2xl grid grid-cols-5 absolute z-20 bg-white  '>
    {
        
      Foot.map((fot,i)=>(
        <div className='w-full h-16 ml-10 bg-white pt-6'>
           <img src={fot.im} alt='footer' className='w-[39px] h-[30px] ml-4'/>
     </div>
      ))  
      
    }
    </div>

</div>
    </section>
  )
}

export default SideEvent
